import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloSejour,cleanAloSejour } from '@/models/alo/AloSejour'
import { AlsSejour, cleanAlsSejour } from '@/models/als/AlsSejour'

export default {
  getAllSejour(): AxiosPromise<AlrContainer<Array<AloSejour>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/Sejour`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloSejour>>
      }]
    })
  },
  getSejour(id:number):AxiosPromise<AlrContainer<AloSejour>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/Sejour/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloSejour>
      }]
    })
  },
  saveSejour(sejour:AloSejour):AxiosPromise<AlrContainer<AloSejour>> {
    cleanAloSejour(sejour)
    if(sejour.id) {
      return  apiHelpers.apiCall({ 
        url: `/webapi/Sejour/${sejour.id}`, 
        method: 'PUT',
        data: sejour,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloSejour>
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `/webapi/Sejour`, 
        method: 'POST',
        data: sejour,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloSejour>
        }]
      })    
    }
  },
  deleteSejour(id:number):AxiosPromise<AlrContainer<AloSejour>>{
    return  apiHelpers.apiCall({ 
      url: `/webapi/Sejour/${id}`, 
      method: 'DELETE',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloSejour>
      }]
    })
  },
  getFilterSejour(sjrFilter : AlsSejour): AxiosPromise<AlrContainer<Array<AloSejour>>> {    
    cleanAlsSejour(sjrFilter)
    return apiHelpers.apiCall({ 
      url: `/webapi/Sejour/filter`, 
      data:sjrFilter,
      method: 'POST',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloSejour>>
      }]
    })
  }
}